import { render, staticRenderFns } from "./wy-performance-overview-panel-conversations-by-languages.vue?vue&type=template&id=1b6c4a72&"
import script from "./wy-performance-overview-panel-conversations-by-languages.vue?vue&type=script&lang=js&"
export * from "./wy-performance-overview-panel-conversations-by-languages.vue?vue&type=script&lang=js&"
import style0 from "./wy-performance-overview-panel-conversations-by-languages.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports